<script>
  import { addMonths, daysOfWeek, monthsOfYear } from "../../date.js";
  import Datepicker from "svelte-calendar";

  export let id;
  export let format = "#{d}/#{m}/#{Y}";
  export let value;
  export let current;
  export let label;
  export let placeholder = "Choisissez une date";
  export let icon = "fa fa-calendar";
  export let required = true;
  export let reset = true;
  export let margin = true;
  export let maxDate = addMonths(new Date(), 120);
  export let minDate = new Date();
  export let selectedDateFormatted;
  export let selectedDate;
</script>

<div class="form-group" class:in={current === id} class:filled={value} class:margin>
  <!-- label -->
  <label class="sr-only" required for={id}>{label}</label>

  <!-- icon -->
  {#if icon != null}
    <div class="icon-left">
      <i class={icon} />
    </div>
  {/if}

  <Datepicker
    {format}
    bind:formattedSelected={selectedDateFormatted}
    bind:selected={selectedDate}
    bind:dateChosen={value}
    start={minDate}
    end={maxDate}
    {daysOfWeek}
    {monthsOfYear}>
    <span {id} class="date" style="position: absolute;z-index:1;">
      {#if value}{selectedDateFormatted}{:else}{placeholder}{/if}
    </span>

    <input
      name={id}
      type="text"
      autocomplete="off"
      class="form-control"
      bind:value
      on:focus={(e) => (current = id)}
      on:blur={() => (current = null)}
      {required} />
  </Datepicker>

  <!-- reset button -->
  {#if reset}
    <div class="icon-right reset">
      <button
        on:click={() => {
          value = null;
        }}
        type="button"
        class="reset"
        tabindex="-1">
        <i class="fa fa-times-circle" />
      </button>
    </div>
  {/if}

  <!-- custom button -->
  <slot />
</div>

<style>
  .date {
    line-height: 40px;
  }

  .form-group {
    display: flex;
    position: relative;
    width: 100%;
    border-radius: 2px;
    background: #efefef;
  }

  .margin.form-group {
    margin-bottom: 15px;
  }

  .readOnly.form-group {
    background: none;
  }

  .in.form-group {
    -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
    box-shadow: 0 2px 0 var(--primary-light-color);
  }
  .in.form-group .icon-left {
    color: var(--primary-color);
  }
  .form-group .icon-left {
    width: 34px;
    padding-top: 10px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1;
    text-align: right;
    background-color: #eee;
    border: 0;
    color: var(--primary-light-color);
  }

  .form-group .icon-right {
    background: 0;
    cursor: pointer;
    padding: 10px 8px 0 5px;
  }

  .form-group:not(.filled) div.reset {
    visibility: hidden !important;
  }

  .form-group .form-control {
    position: relative;
    width: 100%;
    margin-bottom: 0;
    background: #efefef;
  }

  .form-group input {
    -webkit-appearance: none;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 0;
    color: #efefef;
    font-size: 14px;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    resize: none;
    vertical-align: middle;
    width: 100%;
  }

  .form-group button {
    display: block;
  }

  .form-group button:not(:disabled):active {
    background-color: #efefef;
  }

  .form-group button.reset {
    cursor: pointer;
    background: none;
    color: #ccc;
    font-size: 18px;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  :global(.form-group .datepicker) {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: #666;
    font-size: 14px;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    resize: none;
    vertical-align: middle;
    width: 100%;
    text-align: initial !important;
  }

  :global(.form-group button.calendar-button) {
    padding: 0 !important;
  }
</style>
